import { Card, Button } from "antd";
import { UploadOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { TrendingDown } from "lucide-react";

export default function UploadCard() {
  const navigate = useNavigate();

  return (
    <Card className="rounded-3xl border-2 border-dashed">
      <div
        onClick={() => navigate("/optimize")}
        className="cursor-pointer rounded-3xl border border-dashed border-purple-200 bg-white p-6 hover:border-purple-400 hover:shadow-md transition"
      >
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_360px] gap-6 items-center">
          <div>
            <h2 className="text-3xl font-extrabold leading-tight m-0">
              Reduce Shipping. Increase Profit.
            </h2>

            <p className="text-slate-500 mt-4 max-w-md">
              Upload your Meesho product image and find the version with lowest
              shipping charge.
            </p>

            <div className="mt-6 space-y-3">
              <div className="flex items-center gap-2 text-slate-700">
                <span className="text-green-500">✓</span>
                Check 50+ image variations
              </div>

              <div className="flex items-center gap-2 text-slate-700">
                <span className="text-green-500">✓</span>
                Find lowest shipping charge
              </div>

              <div className="flex items-center gap-2 text-slate-700">
                <span className="text-green-500">✓</span>
                Save more on every order
              </div>

              <div className="flex items-center gap-2 text-slate-700">
                <span className="text-green-500">✓</span>
                Only 10 credits per Image optimization
              </div>
            </div>

            <Button
              type="primary"
              icon={<UploadOutlined />}
              className="mt-6 bg-purple-600"
              onClick={(e) => {
                e.stopPropagation();
                navigate("/optimize");
              }}
            >
              Upload Image
            </Button>
          </div>

          <div className="bg-purple-50 rounded-2xl p-4">
            <div className="flex flex-col gap-3">
              <DemoBox
                title="Original Image"
                img="https://upload.meeshosupplyassets.com/cataloging/1781336880464/7xw62_512.png"
              />

              <div className="flex items-center justify-center gap-3">
                <div className="h-[1px] flex-1 bg-purple-200" />

                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-purple-600 shadow-sm">
                  <ArrowDownOutlined />
                </div>

                <div className="bg-green-100 text-green-700 px-3 py-1.5 rounded-full text-xs font-bold">
                  Saved ₹54 🎉
                </div>

                <div className="h-[1px] flex-1 bg-purple-200" />
              </div>

              <DemoBox
                title="Optimized Image"
                optimized
                img="https://upload.meeshosupplyassets.com/cataloging/1781336944099/meesho-image-12.jpg"
              />
            </div>

            <div className="mt-4 bg-green-50 border border-green-200 rounded-xl p-3 flex items-center justify-between">
              <div className="flex items-center gap-2 text-green-700 font-semibold">
                <TrendingDown size={18} />
                Shipping Reduced
              </div>

              <b className="text-green-700">Saved ₹54</b>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}

function DemoBox({ optimized = false, img, title }) {
  return (
    <div
      className={`rounded-xl border p-3 ${optimized ? "bg-green-50 border-green-200" : "bg-white"
        }`}
    >
      <p
        className={`text-xs font-bold mb-2 ${optimized ? "text-green-700" : "text-red-500"
          }`}
      >
        {title}
      </p>

      <div className="flex gap-3">
        <img
          src={img}
          alt=""
          className="w-20 h-20 rounded-md object-cover shrink-0"
        />

        <div className="flex-1">
          <p className="text-[10px] text-slate-500 leading-4 font-normal m-0">Size: M,L,XL,XXL</p>

          <p className="text-slate-400 m-0 mt-1">Meesho Price ₹199</p>

          <p
            className='text-slate-400 m-0 '
          >
            Shipping (added separately) ₹{optimized ? 58 : 112}
          </p>

          <p className="font-bold text-xl m-0">
            ₹{optimized ? 257 : 311}
          </p>
        </div>
      </div>
    </div>
  );
}